import React, { useMemo } from 'react';
import uniqBy from 'lodash/uniqBy';

import Select from 'components/Select';

function AcademyModuleSelect({ sbatGroups, ...remainingProps }) {
  const _styles = {
    control: (styles, state) => ({
      ...styles,
      padding: '0.1rem',
    }),
  };

  const academyModuleOptions = useMemo(() => {
    const academyModules = [];

    sbatGroups.forEach((sbatGroup) =>
      academyModules.push({
        value: sbatGroup.academy_topic.academy_module.id,
        label: sbatGroup.academy_topic.academy_module.name,
      })
    );

    return uniqBy(academyModules, (obj) => obj.value);
  }, [sbatGroups]);

  return (
    <Select
      isMulti
      styles={_styles}
      options={academyModuleOptions}
      placeholder="Select from dropdown"
      {...remainingProps}
    />
  );
}

export default AcademyModuleSelect;
